function myJQueryCode() {
  //Do stuff with jQuery
  (function($){
    var base_url = 'https://leadform.braquets.dev/';

    function update_currency(){
      var currency = $('#advanced-cod').data('currency');
      
      if($('#advanced-cod')[0]){
        var sale = $('sale-price').html().replace('CFA', currency);
            sale = sale.replace('XOF', currency);
        $('sale-price').html(sale);
        
        var compar = $('compare-at-price').html().replace('CFA', currency);
            compar = compar.replace('XOF', currency);
        $('compare-at-price').html(compar);

        var econom = $('on-sale-badge').html().replace('CFA', currency);
            econom = econom.replace('XOF', currency);
        $('on-sale-badge').html(econom);
      }
    }
    
    $( document ).ready(function(){
      $.ajax({
        url: base_url + "customers/getCurrency",
        type: 'POST',
        data: {shop_name: Shopify.shop, product_id: $('#advanced-cod').data('product_id')},
        success:function(response)
        {
          if(response)
              $('#advanced-cod').data('currency', response);
          update_currency();
        }
      });
    });


  })(jQuery);
}

if(typeof jQuery=='undefined') {
  var headTag = document.getElementsByTagName("head")[0];
  var jqTag = document.createElement('script');
  jqTag.type = 'text/javascript';
  jqTag.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js';
  jqTag.onload = myJQueryCode;
  headTag.appendChild(jqTag);
} else {
  myJQueryCode();
}